import { displayNumber } from 'utils/misc';


export const numberFormatter = (value: number): string => {
  if (!value) return '';
  
  return displayNumber(value);
};
